module.exports = __webpack_public_path__ + "static/img/gp-icon1.d06cbda.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/gp-icon1.png
// module id = 0
// module chunks = 0